import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import Main from './Main.js';
import LinkLibraryData from '../../../Models/Content/LinkLibraryBlockData';

export default class LinkLibraryBlock extends EpiComponent<LinkLibraryData> {

  public render(): ReactNode | ReactNodeArray | null {
    const cssClasses: Array<string> = ['link-library-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <Main
          context={this.getContext()}
          iContent={this.props.data}
        />
      </div>
    );
  };
};

